/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ConfirmMembershipDto,
  CreateMembershipDto,
  GetPriceRequestDto,
  JoinWaitlistRequestDto,
  MembershipControllerCancelSubscriptionAutoRenewal201,
  MembershipControllerGetMembership200,
  MembershipControllerRestoreSubscriptionAutoRenewal201,
  MembershipResponse,
  PriceDisplayResponse,
  ProblemDetail,
  UserAuthenticatedResponse
} from '.././model'
import { customFetcher } from '../../../client/customFetcher';



export const membershipControllerCreateSubscription = (
    createMembershipDto: CreateMembershipDto,
 ) => {
      
      
      return customFetcher<MembershipResponse>(
      {url: `/membership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMembershipDto
    },
      );
    }
  


export const getMembershipControllerCreateSubscriptionMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>, TError,{data: CreateMembershipDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>, TError,{data: CreateMembershipDto}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>, {data: CreateMembershipDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerCreateSubscription(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerCreateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>>
    export type MembershipControllerCreateSubscriptionMutationBody = CreateMembershipDto
    export type MembershipControllerCreateSubscriptionMutationError = ProblemDetail

    export const useMembershipControllerCreateSubscription = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>, TError,{data: CreateMembershipDto}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerCreateSubscription>>,
        TError,
        {data: CreateMembershipDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerCreateSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const membershipControllerConfirmSubscription = (
    confirmMembershipDto: ConfirmMembershipDto,
 ) => {
      
      
      return customFetcher<void>(
      {url: `/membership/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmMembershipDto
    },
      );
    }
  


export const getMembershipControllerConfirmSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>, TError,{data: ConfirmMembershipDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>, TError,{data: ConfirmMembershipDto}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>, {data: ConfirmMembershipDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerConfirmSubscription(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerConfirmSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>>
    export type MembershipControllerConfirmSubscriptionMutationBody = ConfirmMembershipDto
    export type MembershipControllerConfirmSubscriptionMutationError = unknown

    export const useMembershipControllerConfirmSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>, TError,{data: ConfirmMembershipDto}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>,
        TError,
        {data: ConfirmMembershipDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerConfirmSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const membershipControllerGetUserPrice = (
    getPriceRequestDto: GetPriceRequestDto,
 ) => {
      
      
      return customFetcher<PriceDisplayResponse>(
      {url: `/membership/price`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getPriceRequestDto
    },
      );
    }
  


export const getMembershipControllerGetUserPriceMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>, TError,{data: GetPriceRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>, TError,{data: GetPriceRequestDto}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>, {data: GetPriceRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerGetUserPrice(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerGetUserPriceMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>>
    export type MembershipControllerGetUserPriceMutationBody = GetPriceRequestDto
    export type MembershipControllerGetUserPriceMutationError = ProblemDetail

    export const useMembershipControllerGetUserPrice = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>, TError,{data: GetPriceRequestDto}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerGetUserPrice>>,
        TError,
        {data: GetPriceRequestDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerGetUserPriceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const membershipControllerGetMembership = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<MembershipControllerGetMembership200>(
      {url: `/membership/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getMembershipControllerGetMembershipQueryKey = (id: string,) => {
    return [`/membership/${id}`] as const;
    }

    
export const getMembershipControllerGetMembershipQueryOptions = <TData = Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError = ProblemDetail>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMembershipControllerGetMembershipQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof membershipControllerGetMembership>>> = ({ signal }) => membershipControllerGetMembership(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData> & { queryKey: QueryKey }
}

export type MembershipControllerGetMembershipQueryResult = NonNullable<Awaited<ReturnType<typeof membershipControllerGetMembership>>>
export type MembershipControllerGetMembershipQueryError = ProblemDetail

export const useMembershipControllerGetMembership = <TData = Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMembershipControllerGetMembershipQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const membershipControllerCancelSubscriptionAutoRenewal = (
    id: string,
 ) => {
      
      
      return customFetcher<MembershipControllerCancelSubscriptionAutoRenewal201>(
      {url: `/membership/${id}/cancel-auto-renewal`, method: 'POST'
    },
      );
    }
  


export const getMembershipControllerCancelSubscriptionAutoRenewalMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  membershipControllerCancelSubscriptionAutoRenewal(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerCancelSubscriptionAutoRenewalMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>>
    
    export type MembershipControllerCancelSubscriptionAutoRenewalMutationError = ProblemDetail

    export const useMembershipControllerCancelSubscriptionAutoRenewal = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>, TError,{id: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMembershipControllerCancelSubscriptionAutoRenewalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const membershipControllerRestoreSubscriptionAutoRenewal = (
    id: string,
 ) => {
      
      
      return customFetcher<MembershipControllerRestoreSubscriptionAutoRenewal201>(
      {url: `/membership/${id}/restart-auto-renewal`, method: 'POST'
    },
      );
    }
  


export const getMembershipControllerRestoreSubscriptionAutoRenewalMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  membershipControllerRestoreSubscriptionAutoRenewal(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerRestoreSubscriptionAutoRenewalMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>>
    
    export type MembershipControllerRestoreSubscriptionAutoRenewalMutationError = ProblemDetail

    export const useMembershipControllerRestoreSubscriptionAutoRenewal = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>, TError,{id: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMembershipControllerRestoreSubscriptionAutoRenewalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const membershipControllerCreateSubscriptionV1 = (
    createMembershipDto: CreateMembershipDto,
 ) => {
      
      
      return customFetcher<MembershipResponse>(
      {url: `/v1/membership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMembershipDto
    },
      );
    }
  


export const getMembershipControllerCreateSubscriptionV1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>, TError,{data: CreateMembershipDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>, TError,{data: CreateMembershipDto}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>, {data: CreateMembershipDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerCreateSubscriptionV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerCreateSubscriptionV1MutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>>
    export type MembershipControllerCreateSubscriptionV1MutationBody = CreateMembershipDto
    export type MembershipControllerCreateSubscriptionV1MutationError = ProblemDetail

    export const useMembershipControllerCreateSubscriptionV1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>, TError,{data: CreateMembershipDto}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>,
        TError,
        {data: CreateMembershipDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerCreateSubscriptionV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const membershipControllerConfirmSubscriptionV1 = (
    confirmMembershipDto: ConfirmMembershipDto,
 ) => {
      
      
      return customFetcher<UserAuthenticatedResponse>(
      {url: `/v1/membership/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmMembershipDto
    },
      );
    }
  


export const getMembershipControllerConfirmSubscriptionV1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>, TError,{data: ConfirmMembershipDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>, TError,{data: ConfirmMembershipDto}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>, {data: ConfirmMembershipDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerConfirmSubscriptionV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerConfirmSubscriptionV1MutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>>
    export type MembershipControllerConfirmSubscriptionV1MutationBody = ConfirmMembershipDto
    export type MembershipControllerConfirmSubscriptionV1MutationError = ProblemDetail

    export const useMembershipControllerConfirmSubscriptionV1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>, TError,{data: ConfirmMembershipDto}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>,
        TError,
        {data: ConfirmMembershipDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerConfirmSubscriptionV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const membershipControllerJoinWaitlist = (
    joinWaitlistRequestDto: JoinWaitlistRequestDto,
 ) => {
      
      
      return customFetcher<UserAuthenticatedResponse>(
      {url: `/v1/membership/waitlist`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: joinWaitlistRequestDto
    },
      );
    }
  


export const getMembershipControllerJoinWaitlistMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerJoinWaitlist>>, TError,{data: JoinWaitlistRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerJoinWaitlist>>, TError,{data: JoinWaitlistRequestDto}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerJoinWaitlist>>, {data: JoinWaitlistRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerJoinWaitlist(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerJoinWaitlistMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerJoinWaitlist>>>
    export type MembershipControllerJoinWaitlistMutationBody = JoinWaitlistRequestDto
    export type MembershipControllerJoinWaitlistMutationError = ProblemDetail

    export const useMembershipControllerJoinWaitlist = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerJoinWaitlist>>, TError,{data: JoinWaitlistRequestDto}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerJoinWaitlist>>,
        TError,
        {data: JoinWaitlistRequestDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerJoinWaitlistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    